import { API } from './api';

interface ServerInitStore {
  baseUrlApi?: string | { value: string };
  lang?: string;
}

interface Params {
  token?: string;
  [key: string]: any;
}

class ServerInitService extends API {
  constructor(store?: ServerInitStore, params?: Params) {
    super(store, params);
  }

  override generateUrl(): string {
    throw new Error('generateUrl should not be called directly. Use specific methods.');
  }

  generateTranslationsUrl(): string {
    return 'translations/';
  }

  generateStatusUrl(): string {
    const lang = (this.store as ServerInitStore)?.lang || 'da';
    return ['status/', lang].join('');
  }

  generateCategoriesUrl(): string {
    const lang = (this.store as ServerInitStore)?.lang || 'da';
    return ['channel/', lang].join('');
  }

  generateCategoryStatusUrl(nodeId: string | number): string {
    const lang = (this.store as ServerInitStore)?.lang || 'da';
    return ['channel/', lang, '/', nodeId, '/status'].join('');
  }

  async getTranslations(): Promise<any> {
    this.generateUrl = this.generateTranslationsUrl;
    return await this.fetchData();
  }

  async getStatus(): Promise<any> {
    this.generateUrl = this.generateStatusUrl;
    return await this.fetchData();
  }

  async getCategoryStatus(nodeId: string | number): Promise<any> {
    this.generateUrl = () => this.generateCategoryStatusUrl(nodeId);
    return await this.fetchData();
  }

  async getCategories(): Promise<any> {
    this.generateUrl = this.generateCategoriesUrl;
    return await this.fetchData();
  }
}

export default ServerInitService;
export { ServerInitService };
